import React, { useEffect } from 'react'
import { Tabs } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { checkMenu, checkLogin } from '@/utils'
import ExponentRank from './components/exponentRank'
import SoldRank from './components/soldRank'
import SoldPriceRank from './components/soldPriceRank'
import './index.scss'

const tabsList = [
  {
    key: '0',
    label: '武房指数榜',
    children: <ExponentRank />
  },
  {
    key: '1',
    label: '新房销量榜',
    children: <SoldRank />
  },
  {
    key: '2',
    label: '新房销售额榜',
    children: <SoldPriceRank />
  }
]

export default function Index() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
  }, [])
  return (
    <div>
      <div className="pageTitle">
        <div className="pageTitle-name">武房通榜单</div>
      </div>
      <div className="tabs">
        <Tabs defaultActiveKey="0" items={tabsList} />
      </div>
    </div>
  )
}
